//@ts-nocheck
// This file is the entry for Webpack and Parcel fallback.

import { parse } from 'cookie';
import { v4 as uuidv4 } from 'uuid';

import { initializeFeatureGatesClient } from './feature-gates/initialization';
import { getRoute } from './get-route';
import { init as initRelay } from './init-relay-streaming';
import { init } from './init-streaming';
import { fetchRoutingTable } from './utils/dynamic-routing/dynamic-routing-utils';
import {
	overrideAjsAnonIdFromCookie,
	overrideCustomAttributes,
	isEdgeCachingPath,
} from './utils/fg-bootstrap-values-override-utils';
import {
	extractOptanonConsentCookie,
	isPerformanceOnetrustEnabled,
} from './utils/onetrust-provider';
import { processExperimentAndFeatureGateOverrides } from './utils/wac-browser-utility';

window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
	identifiers: {
		analyticsAnonymousId: uuidv4(),
	},
};

const parsedClientCookies = document.cookie ? parse(document.cookie) : {};
const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';

const locationData = {
	countryIsoCode: window.countryCode || '',
	regionIsoCode: window.regionIsoCode || '',
};

const isPerfOnetrustEnabled = isPerformanceOnetrustEnabled(
	typeof window !== 'undefined'
		? window.optanonConsentCookie
		: extractOptanonConsentCookie(document.cookie),
	locationData,
);

const { finalExperimentOverrides, finalFeatureGateOverrides } =
	processExperimentAndFeatureGateOverrides(parsedClientCookies, userAgent, isPerfOnetrustEnabled);

if (isEdgeCachingPath(window.location.pathname)) {
	overrideAjsAnonIdFromCookie();
	overrideCustomAttributes();
}

initializeFeatureGatesClient(window.featureGateBootstrapValues, {
	overrideValues: {
		experimentOverrides: finalExperimentOverrides,
		featureGateOverrides: finalFeatureGateOverrides,
	},
	localMode: !isPerfOnetrustEnabled,
}).then(async () => {
	const routingTable = await fetchRoutingTable();
	const { Component, isRelayEnabled, query, queryVars, relayApi } = getRoute(
		window.location,
		undefined,
		undefined,
		undefined,
		routingTable,
	);
	if (!isRelayEnabled) {
		init(Component);
	} else {
		initRelay(Component, query, queryVars, relayApi);
	}
});
